import React, {useEffect, useState} from 'react';
import {FormElements} from "../../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../../shared/utils/forms/useForm";
import {UseFormSubmitModel} from "../../../../shared/utils/forms/models/UseFormModel";
import {required} from "../../../../shared/utils/forms/utils/validationType";
import BtnRow from "../../../../shared/ui/form/BtnRow";
import ElementCompanyHours from "./ElementCompanyHours";
import http from "../../../../shared/utils/http";
import {useSelector} from "react-redux";
import {loadEmployeesAction, selectSelectedPharmacist} from "../../../../core/reducer/auth/authSlice";
import {typeHoursInitArray} from "../../../../common/typeHours";
import {useAppDispatch} from "../../../../app/hooks";
import {selectSelectedPharmacy} from "../../../../core/reducer/pharmacySlice";
import ElementCompanyHoursEdit from "./ElementCompanyHoursEdit";

const FormAddEmployee = ({closeFormHandler, dataEdit}: { closeFormHandler: () => void, dataEdit: any }) => {
    const dispatch = useAppDispatch()
    const pharmacist = useSelector(selectSelectedPharmacist)
    const selectedPharmacy = useSelector(selectSelectedPharmacy);

    useEffect(() => {
        if (dataEdit?.id) {
            http.get(`pharmacists/${dataEdit?.idPharmacist}/employees/${dataEdit?.idDocument}/init`).then(res => {
                setData({...dataEdit, ...res?.init})
            })
        }
    }, [dataEdit]);

    const submitActionHandler: UseFormSubmitModel = (data, d) => {
        if (dataEdit?.id) {
            const dataToSent = {
                color: d.color,
                pharmacy: {
                    work: d.work,
                    work_sunday: d.work_sunday,
                    work_festive: d.work_festive,
                    hoursOfLeave: d.hoursOfLeave,
                    vacationHours: d.vacationHours,
                    sick: d.sick,
                    festive: d.festive,
                    extraHours: d.extraHours,
                },
                surname: d.surname,
                name: d.name,
            }
            http.patch(`pharmacists/${pharmacist}/employees/${dataEdit?.idDocument}`, dataToSent).then(res => {
                dispatch(loadEmployeesAction())
                closeFormHandler && closeFormHandler()
            })
        } else {
            http.post(`pharmacists/${pharmacist}/employees`, d).then(res => {
                dispatch(loadEmployeesAction())
                closeFormHandler && closeFormHandler()
            })
        }
    }
    const validations = [
        {
            name: 'surname',
            validations: [
                {
                    name: required,
                    params: {name: "cognome"},
                },
            ],
        },
        {
            name: 'name',
            validations: [
                {
                    name: required,
                    params: {name: "nome"},
                },
            ],
        },
        {
            name: 'email',
            validations: [
                {
                    name: required,
                    params: {name: "email"},
                },
            ],
        },
        {
            pharmacies: {
                form: [
                    {
                        name: 'pharmacy',
                        validations: [
                            {
                                name: required,
                                params: {name: "pharmacy"},
                            },
                        ],
                    },
                    {
                        name: 'weeklyContractHours',
                        validations: [
                            {
                                name: required,
                                params: {name: ""},
                            },
                        ],
                    },
                    ...typeHoursInitArray.map(ele => ({
                        name: ele.name,
                        validations: [
                            {
                                name: required,
                                params: {name: ""},
                            },
                        ],
                    }))
                ]
            }

        }
    ]
    const validationsEdit = [
        {
            name: 'surname',
            validations: [
                {
                    name: required,
                    params: {name: "cognome"},
                },
            ],
        },
        {
            name: 'name',
            validations: [
                {
                    name: required,
                    params: {name: "nome"},
                },
            ],
        },
        {
            name: 'email',
            validations: [
                {
                    name: required,
                    params: {name: "email"},
                },
            ],
        },

        ...typeHoursInitArray.map(ele => ({
            name: ele.name,
            validations: [
                {
                    name: required,
                    params: {name: ""},
                },
            ],
        }))


    ]

    const structureDataCompanyName: StructureFormModel[] = [
        {
            type: formControlTypes.input,
            name: "surname",
            label: "Cognome",
            dataElement: {
                placeholder: "Inserisci cognome",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
        {
            type: formControlTypes.input,
            name: "name",
            label: "Nome",
            dataElement: {
                placeholder: "Inserisci nome",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
        {
            type: formControlTypes.input,
            name: "email",
            label: "Email",
            dataElement: {
                placeholder: "Inserisci email",
                type: 'text',
                disabled: !!dataEdit?.idDocument,
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
        {
            type: formControlTypes.color,
            name: "color",
            label: "Colore",
            dataElement: {
                placeholder: "",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        }
    ]

    const {
        dataFormatted,
        dataForm,
        setData,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitActionHandler, dataEdit?.id ? validationsEdit : validations)

    const setDataHandler = (newDataFormatted: any[], name: string) => {
        setData({...dataFormatted, [name]: newDataFormatted})
    }
    useEffect(() => {
        setData({color: '#ffc205', pharmacies___0___pharmacy: selectedPharmacy?.idDocument})
    }, [selectedPharmacy]);

    return (
        <div>
            <div className={'form-container'}>
                <FormElements structure={structureDataCompanyName} changeValue={changeValue} dataForm={dataForm}
                              errors={errors} isSubmit={isSubmit}/>
                <div>
                    {dataEdit?.idDocument ?
                        <ElementCompanyHoursEdit dataForm={dataForm} changeValue={changeValue} errors={errors}/>
                        :
                        <ElementCompanyHours setData={setDataHandler} dataForm={dataForm}
                                             dataFormatted={dataFormatted?.pharmacies || []} pre={'pharmacies'}
                                             changeValue={changeValue} errors={errors}/>}
                </div>
            </div>

            <BtnRow submitAction={submitAction} closeFormHandler={closeFormHandler}/>

        </div>
    );
};

export default FormAddEmployee;
